import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { HotspotVoucherResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const hotspotVoucher = {
    record(data: typeof Requests.HotspotVoucher.Record.Input) {
        return post<typeof data, HotspotVoucherResponseTypes.Record>(
            `/hotspot-voucher/record`,
            data,
        );
    },
    resellerRecord(data: typeof Requests.HotspotVoucher.ResellerRecord.Input) {
        return post<typeof data, HotspotVoucherResponseTypes.ResellerRecord>(
            `/hotspot-voucher/reseller-record`,
            data,
        );
    },
    create(data: typeof Requests.HotspotVoucher.Create.Input) {
        return post<typeof data>(`/hotspot-voucher/create`, data);
    },
    obtain(id: string) {
        return get<HotspotVoucherResponseTypes.Obtain>(`/hotspot-voucher/obtain/${id}`);
    },
    groups() {
        return get<HotspotVoucherResponseTypes.Groups>(`/hotspot-voucher/groups`);
    },
    groupVouchers(group: string) {
        return get<HotspotVoucherResponseTypes.GroupVouchers>(
            `/hotspot-voucher/group-vouchers/${group}`,
        );
    },
    render(data: typeof Requests.HotspotVoucher.Render.Input) {
        return post<typeof data>(`/hotspot-voucher/render`, data);
    },
    disconnect(id: string) {
        return postEmpty(`/hotspot-voucher/disconnect/${id}`);
    },
    formHooks: {
        groups: (async (param?: SelectParam) => {
            const req = get<HotspotVoucherResponseTypes.Groups>(
                `/hotspot-voucher/groups` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.HotspotVoucher.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/hotspot-voucher/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
